module.exports = __webpack_public_path__ + "img/omics5.3052005b.png";